export default function (instance) {
    return {
        // TAGS
        getListTags(caseId) {
            return instance.get(`/tag/case/${caseId}`);
        },
        addNewCategory(caseId, data) {
            return instance.post(`/tag/case/${caseId}/category`, data);
        },
        editCategory(caseId, categoryId, data) {
            return instance.put(`/tag/case/${caseId}/category/${categoryId}`, data);
        },
        removeCategory(caseId, categoryId) {
            return instance.delete(`/tag/case/${caseId}/category/${categoryId}`);
        },
        changeCategoryOrder(caseId, data) {
            return instance.post(`/tag/case/${caseId}/category/order`, data);
        },
        addNewTag(caseId, categoryId, data) {
            return instance.post(`/tag/case/${caseId}?categoryId=${categoryId}`, data);
        },
        editTag(caseId, tagId, data) {
            return instance.put(`/tag/case/${caseId}/tag/${tagId}`, data);
        },
        removeTag(tagId, caseId) {
            return instance.delete(`/tag/${tagId}/case/${caseId}`);
        },
        changeTagOrder(caseId, data) {
            return instance.post(`/tag/case/${caseId}/order`, data);
        },

        // TAGS TAB ENDPOINTS
        getListTagsByChatId(caseId, chatId) {
            return instance.get(`/tag/case/${caseId}/chat/${chatId}`);
        },

        // MESSAGES BY TAGS
        getMessagesByTags(caseId, chatId, params) {
            return instance.get(
                `/messages/${caseId}/chat/${chatId}/messages/tags`,
                {params}
            );
        },

        // CHAT MESSAGES
        getChatMessages(caseId, chatId, params) {
            return instance.get(
                `/messages/${caseId}/chat/${chatId}/messages`,
                {params}
            );
        },

        // MESSAGE DETAILS & TAGS
        getMessageById(caseId, messageId, chatId) {
            return instance.get(
                `/messages/${caseId}/message/${messageId}/chat/${chatId}`
            );
        },
        getMessageListTags(caseId, messageId) {
            return instance.get(
                `/messages/${caseId}/message/${messageId}/tags`
            );
        },
        addTagToMessage(caseId, messageId, tagId) {
            return instance.post(
                `/messages/${caseId}/message/${messageId}/tag/${tagId}`,
                {}
            );
        },
        removeTagFromMessage(caseId, messageId, tagId) {
            return instance.delete(
                `/messages/${caseId}/message/${messageId}/tag/${tagId}`
            );
        },
        blurMessage(caseId, messageId) {
            return instance.put(
                `/messages/${messageId}/case/${caseId}/blur`, {}
            );
        },
        unblurMessage(caseId, messageId) {
            return instance.put(
                `/messages/${messageId}/case/${caseId}/unblur`, {}
            );
        },
        showBlurredMessage(caseId, messageId) {
            return instance.get(
                `/messages/${messageId}/case/${caseId}`
            );
        },

        // COMMENTS
        getListCommentsByChatId(caseId, chatId, params) {
            return instance.get(
                `/messages/${caseId}/chat/${chatId}/comments`,
                {params}
            );
        },
        getCommentsByMessageId(caseId, messageId) {
            return instance.get(
                `/messages/${caseId}/message/${messageId}/comments`
            );
        },
        createCommentForMessage(caseId, messageId, data) {
            return instance.post(
                `/messages/${caseId}/message/${messageId}/comment`,
                data
            );
        },
        updateComment(caseId, commentId, data) {
            return instance.put(
                `/messages/${caseId}/comment/${commentId}`,
                data
            );
        },
        deleteComment(caseId, commentId) {
            return instance.delete(
                `/messages/${caseId}/comment/${commentId}`
            );
        },

        // PINNED
        getListPinnedMessages(caseId, chatId, params) {
            return instance.get(
                `/messages/${caseId}/chat/${chatId}/messages/pin`,
                {params}
            );
        },
        pinMessage(caseId, chatId, messageId) {
            return instance.post(
                `/messages/${caseId}/chat/${chatId}/message/${messageId}/pin`, {}
            );
        },
        unpinMessage(caseId, chatId, messageId) {
            return instance.delete(
                `/messages/${messageId}/case/${caseId}/chat/${chatId}/pin`
            );
        },

        // HIGHLIGHT
        getListHighlightMessages(caseId, chatId, params) {
            return instance.get(
                `/messages/${caseId}/chat/${chatId}/messages/highlight`,
                {params}
            );
        },
        createHighlightForMessage(caseId, messageId, color) {
            return instance.post(
                `/messages/${caseId}/message/${messageId}/highlight`,
                null,
                {params: {color}}
            );
        },
        deleteHighlightForMessage(caseId, messageId) {
            return instance.delete(
                `/messages/${caseId}/message/${messageId}/highlight`
            );
        },

        // REMINDERS
        getReminderMessages(caseId, chatId, params) {
            return instance.get(
                `/messages/${caseId}/chat/${chatId}/messages/reminder`,
                {params}
            );
        },
        addReminder(data) {
            return instance.post('/reminder', data);
        },
        editReminder(caseId, reminderId, data) {
            return instance.put(
                `/reminder/case/${caseId}/${reminderId}`,
                data
            );
        },
        deleteReminder(caseId, reminderId) {
            return instance.delete(
                `/reminder/case/${caseId}/${reminderId}`
            );
        },
        markAsCompleteReminder(caseId, reminderId) {
            return instance.post(
                `/reminder/case/${caseId}/${reminderId}`, {}
            );
        },
        countActiveReminders(caseId, chatId) {
            return instance.get(
                `/reminder/case/${caseId}/chat/${chatId}/count`
            );
        },
    };
}
